<template>
    <div class="af" >
        <div class="flex alc" id="toolH">
            <!--<el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="$t('invoiceEntry_please_enter_the_batch_number/product_name_to_search')" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>-->
            <el-form ref="form" :model="form" label-width="100px" size="mini" inline>
                <el-form-item :label="$t('invoiceEntry_invoice_quantity')" v-if="i_isfrom==1">
                    <span>{{form.f_num_fp}}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')">
                    <span>{{form.f_je_ws_cw}}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceEntry_invoice_tax_amount')">
                    <span>{{form.f_je_zzs_cw}}</span>
                </el-form-item>
            </el-form>
            <el-form ref="form" :model="remainingAmount" label-width="100px" size="mini" inline>
                <el-form-item :label="$t('invoiceEntry_remaining_quantity')"  v-if="i_isfrom==1">
                    <span>{{ remainingAmount.f_currentrelate_num_fp}}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceEntry_remaining_amount')">
                    <span>{{ remainingAmount.f_je_ws}}</span>
                </el-form-item>
                <el-form-item :label="$t('invoiceEntry_remaining_tax_amount')">
                    <span>{{ remainingAmount.f_je_zzs}}</span>
                </el-form-item>
            </el-form>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                :height="tableHeight"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @select="select"
                @selection-change="handleSelectionChange"
                :row-key="row => row.uniqueKey"
                :default-selection="defaultSelectedRows"
                show-summary
                :summary-method="getSummaries"
        >
            <!--:selectable="checkSelectable"-->
            <el-table-column
                    align="center"
                    type="selection"

                    :reserve-selection="true"
                    width="50">
            </el-table-column>
            <el-table-column
                    align="center"
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="i_order_type"
                    :label="$t('invoiceEntry_type')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.i_order_type==1?$t('invoiceEntry_warehouse_receipt'):(scope.row.i_order_type==2?$t('invoiceEntry_loss_in_transit_order'):(scope.row.i_order_type==3?$t('invoiceEntry_orders_in_transit'):''))}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="i_order_pid"
                    :label="$t('invoiceEntry_document_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    :label="$t('form_batch_number')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="f_num_tol"
                    :label="$t('invoiceEntry_total_order_quantity')"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="vc_unit"
                    :label="$t('form_unit')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_fkpay_tol"
                    :label="$t('invoiceEntry_amount_already_paid_for_the_order')"
                    show-overflow-tooltip
                    width="110">
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_related_num"
                    :label="$t('invoiceEntry_already_associated_quantity')"
                    show-overflow-tooltip
                    width="110">
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_canrelate_num"
                    :label="$t('invoiceEntry_can_be_associated_with_quantity')"
                    show-overflow-tooltip
                    width="110">
            </el-table-column>
            <el-table-column
                    prop="f_currentrelated_num"
                    :label="$t('invoiceEntry_number_of_this_association')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number :disabled="form.f_je_ws_cw<0" @change="inbcfnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_currentrelated_num" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_bl"
                    :label="$t('invoiceEntry_proportion')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_price_ws"
                    :label="$t('invoiceEntry_order_pnit_price')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <span v-if="i_isfrom==1">{{scope.row.f_price_ws}}</span>
                    <el-input-number v-else @change="inprice(tableData,scope.$index,scope.row)" :controls="false" :precision="2" size="mini" v-model="scope.row.f_price_ws" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_currentrelate_num_fp"
                    :label="$t('invoiceEntry_invoice_quantity')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <!--<span v-if="scope.row.f_bl_copy!=0">{{scope.row.f_currentrelate_num_fp}}</span>-->
                    <el-input-number v-if="scope.row.f_bl_copy!=1" :disabled="form.f_je_ws_cw<0" @change="wcfpnum(tableData,scope.$index,scope.row)" :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_currentrelate_num_fp" ></el-input-number>
                    <el-input-number v-else :disabled="form.f_je_ws_cw<0" @change="infpnum(tableData,scope.$index,scope.row)" :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_currentrelate_num_fp" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_fpunit"
                    :label="$t('invoiceEntry_invoice_unit')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    :label="$t('invoiceEntry_invoice_pnit_price')"
                    show-overflow-tooltip
                    width="130"
                    align="right">
                <span>{{form.f_price_ws_fp}}</span>
            </el-table-column>
            <el-table-column
                    prop="f_je_ws"
                    :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number @change="inpayws(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_je_ws" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_sl"
                    :label="$t('form_tax_rate')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_je_zzs"
                    :label="$t('invoiceEntry_tax_amount')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number @change="inpayzzs(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_je_zzs" ></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <!--<el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[500, 1000, 1500]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>-->
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button  type="primary" @click="confirm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto'}"
                top="15vh"
                width="85%"
                :title="$t('invoiceEntry_write-off_details')"
                :visible.sync="dialogVisible_choo"
                :close-on-click-modal="false"
                @close="closechoo"
                v-if="dialogVisible_choo"
                :append-to-body="true">
            <el-table border :data="multipleSelection" :height="tableHeight2" class="el-child-table marT10" ref="table" size="mini" :header-cell-style="{background:'#eef1f6',color:'#000'}">
                <el-table-column align="center" type="index" label="" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="i_order_type" :label="$t('invoiceEntry_type')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.i_order_type==1?$t('invoiceEntry_warehouse_receipt'):(scope.row.i_order_type==2?$t('invoiceEntry_loss_in_transit_order'):(scope.row.i_order_type==3?$t('invoiceEntry_orders_in_transit'):''))}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="i_order_pid" :label="$t('invoiceEntry_document_number')" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="vc_pzname" :label="$t('form_product_name')" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column align="center" prop="vc_no" :label="$t('form_batch_number')" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column align="center" prop="f_num_tol" :label="$t('invoiceEntry_total_order_quantity')" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="vc_unit" :label="$t('form_unit')" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="f_fkpay_tol" :label="$t('invoiceEntry_amount_already_paid_for_the_order')" show-overflow-tooltip width="110"></el-table-column>
                <!--<el-table-column align="center" prop="f_related_num" :label="$t('invoiceEntry_already_associated_quantity')" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column align="center" prop="f_canrelate_num" :label="$t('invoiceEntry_can_be_associated_with_quantity')" show-overflow-tooltip></el-table-column>-->
                <el-table-column align="center" prop="f_currentrelated_num" :label="$t('invoiceEntry_number_of_this_association')" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column align="center" prop="f_bl" :label="$t('invoiceEntry_proportion')" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="vc_fpunit" :label="$t('invoiceEntry_invoice_unit')" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="f_currentrelate_num_fp" :label="$t('invoiceEntry_invoice_quantity')" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column align="center" prop="f_price_ws" :label="$t('invoiceEntry_invoice_pnit_price')" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column align="center" prop="f_je_ws" :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')" show-overflow-tooltip width="130"></el-table-column>
                <el-table-column align="center" prop="f_sl" :label="$t('form_tax_rate')" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="f_je_zzs" :label="$t('invoiceEntry_tax_amount')" show-overflow-tooltip width="130"></el-table-column>
            </el-table>
            <div style="text-align: center;padding: 6px">
                <el-button  type="primary" @click="savehx"  :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
                <el-button @click="closechoo" size="small">{{$t('button_cancel')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {

        },
        props: {
            Data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                dialogVisible_choo:false,
                dialogVisible:false,
                choozt:false,
                tableHeight: 400,
                tableHeight2:400,
                maxDialogHeight:0,
                loading:false,
                dt_startdate:'',
                dt_enddate:'',
                vc_search:"",
                valuetime:'',
                baseerp: "",
                mid: 0,
                expend:false,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                pageSize: 500,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
                currentInvoiceId: null,
                selectedPid: null,
                form:{},
                selectedTotal: {
                    f_currentrelate_num_fp: 0,
                    f_je_ws: 0,
                    f_je_zzs: 0
                },
                remain: {
                    f_num_fp: 0,
                    f_je_ws_cw: 0,
                    f_je_zzs_cw: 0
                },
                i_isfrom:1,
                i_checkstate:0,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        computed: {
            defaultSelectedRows() {
                // 返回当前选中的数据用于 default-selection
                return this.multipleSelection;
            },
            remainingAmount() {
                return {
                    f_currentrelate_num_fp: (this.remain.f_num_fp - this.selectedTotal.f_currentrelate_num_fp).toFixed(this.$setPrecision.quantityPrecision),
                    f_je_ws: this.keepTwoDecimal(this.remain.f_je_ws_cw - this.selectedTotal.f_je_ws),
                    f_je_zzs: this.keepTwoDecimal(this.remain.f_je_zzs_cw - this.selectedTotal.f_je_zzs)
                };
            },

            // 排除已选择的数据
            filteredData() {
                return this.tableData.filter(item => !this.dataZt.select.includes(item.uniqueKey));
            },
        },
        watch:{
            tableData:{
                deep:true,
                handler(){
                    this.changeselT()
                }
            }
        },
        mounted() {
            //this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("Data", this.Data);
            this.remain=this.Data.remain;
            this.form=this.Data.row;
            this.fppay=(this.remain.f_je_ws_cw+this.remain.f_je_zzs_cw).toFixed(this.$setPrecision.quantityPrecision);
            //console.log(this.fppay,'this.fppay')
            this.getOrders(this.Data.type);
            this.baseerp = baseerp;

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            updateTableHeight() {
                //console.log(this.Data.maxDialogHeight,'this.Data.maxDialogHeight');
                const dialogHeight = this.Data.maxDialogHeight ; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = 415;
                this.tableHeight = dialogHeight - otherHeight;
                this.tableHeight2 =  dialogHeight - otherHeight - 100;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight=dialogHeight;
            },
            savehx(){
                if(this.multipleSelection==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_order_to_be_cancelled'));
                    return
                }
                this.$confirm(this.$t('invoiceEntry_after_saving_the_verification_data_will_take_effect_directly_are_you_sure_you_want_to_continue'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_confirm'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.multipleSelection.forEach(item => {
                        item.i_id = item.i_cw_id;
                    });
                    let map={},fpProcessMains=[];
                    map.vc_lruname=sessionStorage.getItem("lruname");
                    map.i_lruid=sessionStorage.getItem("userid");
                    map.i_fpid=this.form.i_fpid;
                    map.f_num=this.selectedTotal.f_currentrelate_num_fp;
                    map.purchaseCwInvoices=this.multipleSelection;
                    fpProcessMains.push(map);
                    this.save(fpProcessMains)
                }).catch(() => {

                });
            },
            //保存
            async save(fpProcessMains) {
                this.loading = true;
                let param = {
                    fpProcessMains:fpProcessMains
                };
                //console.log(param, 'param')
                let res = await API.writeoffInvoiceInTransit(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.$emit('confirmzt',{type:'save'})
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            closechoo(){
              this.dialogVisible_choo=false;
            },
            //除
            preciseDiv(dividend, divisor) {
                if(dividend&&divisor){
                    //console.log(dividend,"////",divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = (intDividend / intDivisor).toFixed(this.$setPrecision.quantityPrecision);
                    //console.log(result,'result------')
                    return result ;
                }
            },
            inprice(data,index,row){
                if(row.f_price_ws < 0){
                    row.f_price_ws = 0;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_unit_price_on_the_invoice_must_not_be_less_than_0'));
                    this.refreshTable();
                    return ;
                }
                //let payws = row.f_currentrelate_num_fp*row.f_price_ws;
                let payws = row.f_currentrelated_num*row.f_price_ws;
                row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                //let payzzs = row.f_currentrelate_num_fp*row.f_price_ws*row.f_sl;
                let payzzs = row.f_currentrelated_num*row.f_price_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                //console.log(row,'row');
                this.$set(data,index,row);
                //this.changeselT()
            },
            inpayws(data,index,row){
                //let cenzzs = row.f_currentrelate_num_fp * row.f_price_ws;
                let cenzzs = row.f_currentrelated_num * row.f_price_ws;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                if(this.Data.row.f_je_ws_cw>0&&(row.f_je_ws<less||row.f_je_ws>more)){
                    this.$nextTick(()=>{
                        row.f_je_ws = cenzzs;
                    })
                    this.$message.error(this.$t('invoiceEntry_the_tax-free_price_must_not_exceed_or_fall_short_of_the_set_price_by_more_than')+cenzzs+"±1！！");
                    this.$set(data,index,row);
                    return
                }
                let fzzs = row.f_je_ws * row.f_sl;
                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                row.f_je_zzs = fzzs;
                this.$set(data,index,row);
                //this.changeselT()
            },
            inpayzzs(data,index,row){
                let cenzzs = row.f_je_ws * row.f_sl;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                if(this.Data.row.f_je_ws_cw>0&&(row.f_je_zzs<less||row.f_je_zzs>more)){
                    this.$nextTick(()=>{
                        row.f_je_zzs = cenzzs;
                    })
                    this.$message.error(this.$t('invoiceEntry_the_tax_amount_must_not_exceed_or_be_less_than_the_established_tax_amount_by_more_than')+cenzzs+"±1！");
                }
                this.$set(data,index,row);
                //this.changeselT()
            },
            wcfpnum(data,index,row){
                let maxfpnum = row.f_currentrelated_num==0?0:this.preciseDiv(row.f_currentrelated_num,row.f_bl);
                //console.log("maxfpnum",maxfpnum)
                let more = Number(maxfpnum) + 0.1;
                let less = Number(maxfpnum)<=0.1?0:Number(maxfpnum) - 0.1;
                //console.log("more",more,"less",less)
                if (row.f_currentrelate_num_fp < less || row.f_currentrelate_num_fp > more) {
                    this.$nextTick(() => {
                        row.f_currentrelate_num_fp = maxfpnum;
                    })
                    this.$message.error(this.$t('invoiceEntry_the_number_of_invoices_cannot_exceed_or_be_less_than_the_predetermined_quantity') + maxfpnum + "±0.1！");
                    this.$set(data,index,row);
                    return ;
                }
                //let payws = row.f_currentrelate_num_fp*row.f_price_ws;
                let payws = row.f_currentrelated_num*row.f_price_ws;
                row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                //let payzzs = row.f_currentrelate_num_fp*row.f_price_ws*row.f_sl;
                let payzzs = row.f_currentrelated_num*row.f_price_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                //console.log(row,'row');
                this.$set(data,index,row);
                //this.changeselT()
            },
            infpnum(data,index,row){
                if(row.f_currentrelate_num_fp > this.form.f_bcfpnum){
                    row.f_currentrelate_num_fp = row.f_currentrelated_num;
                    row.f_bl=1;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_associated_quantity_cannot_exceed_the_allowable_associated_quantity'));
                    this.refreshTable();
                    return ;
                }
                let bl = parseFloat(this.preciseDiv(row.f_currentrelated_num,row.f_currentrelate_num_fp));
                //row.f_bl=parseFloat(this.keepTwoDecimal(bl));
                row.f_bl=parseFloat(bl.toFixed(10));//blyaogai
                //let payws = row.f_currentrelate_num_fp*row.f_price_ws;
                let payws = row.f_currentrelated_num*row.f_price_ws;
                row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                //let payzzs = row.f_currentrelate_num_fp*row.f_price_ws*row.f_sl;
                let payzzs = row.f_currentrelated_num*row.f_price_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                //console.log(row,'row');
                this.$set(data,index,row);
                //this.changeselT()
            },
            inbcfnum(data,index,row){
                if(row.f_currentrelated_num <= 0){
                    row.f_currentrelated_num = row.f_canrelate_num;
                    if(row.f_bl==0){
                        let bl = row.f_currentrelate_num_fp==0?0:parseFloat(this.preciseDiv(row.f_currentrelated_num,row.f_currentrelate_num_fp));
                        //row.f_bl=parseFloat(this.keepTwoDecimal(bl));
                        row.f_bl=parseFloat(bl.toFixed(10));//blyaogai
                    }
                    row.f_currentrelate_num_fp=this.preciseDiv(row.f_currentrelated_num,row.f_bl);
                    //let payws =parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws;
                    let payws =parseFloat(row.f_currentrelated_num)*row.f_price_ws;
                    row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                    //let payzzs = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws*row.f_sl;
                    let payzzs = parseFloat(row.f_currentrelated_num)*row.f_price_ws*row.f_sl;
                    row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));

                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_quantity_must_not_be_less_than_or_equal_to_0'));
                    this.refreshTable();
                    return ;
                }
                if(row.f_currentrelated_num > row.f_canrelate_num){
                    row.f_currentrelated_num = row.f_canrelate_num;
                    if(row.f_bl==0){
                        let bl = row.f_currentrelate_num_fp==0?0:parseFloat(this.preciseDiv(row.f_currentrelated_num,row.f_currentrelate_num_fp));
                        //row.f_bl=parseFloat(this.keepTwoDecimal(bl));
                        row.f_bl=parseFloat(bl.toFixed(10));//blyaogai
                    }
                    row.f_currentrelate_num_fp=this.preciseDiv(row.f_currentrelated_num,row.f_bl);
                    //let payws = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws;
                    let payws = parseFloat(row.f_currentrelated_num)*row.f_price_ws;
                    row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                    //let payzzs = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws*row.f_sl;
                    let payzzs = parseFloat(row.f_currentrelated_num)*row.f_price_ws*row.f_sl;
                    row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));

                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_associated_quantity_cannot_exceed_the_allowable_associated_quantity'));
                    this.refreshTable();
                    return ;
                }
                if(row.f_bl==0){
                    let bl = row.f_currentrelate_num_fp==0?0:parseFloat(this.preciseDiv(row.f_currentrelated_num,row.f_currentrelate_num_fp));
                    //row.f_bl=parseFloat(this.keepTwoDecimal(bl));
                    row.f_bl=parseFloat(bl.toFixed(10));//blyaogai
                }
                row.f_currentrelate_num_fp=this.preciseDiv(row.f_currentrelated_num,row.f_bl);
                //let payws = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws;
                let payws = parseFloat(row.f_currentrelated_num)*row.f_price_ws;
                row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                //let payzzs = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws*row.f_sl;
                let payzzs = parseFloat(row.f_currentrelated_num)*row.f_price_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                //console.log(row,'row');
                this.$set(data,index,row);
                //this.changeselT()
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })

                this.multipleSelection=[];
                this.currentPage=1;
                this.tableData=[];
                this.changeselT();
                this.getOrders(0);
            },

            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                    this.restoreSelection()
                })
            },
            restoreSelection() {
                this.$nextTick(() => {
                    this.multipleSelection.forEach(selectedRow => {
                        const matched = this.tableData.find(item => item.uniqueKey === selectedRow.uniqueKey);
                        if (matched) {
                            this.$refs.table.toggleRowSelection(matched, true);
                        }
                    });
                });
            },
            select(val,row){
                if(this.Data.row.f_je_ws_cw<0&&val.length>1&&this.i_isfrom==1){
                    let idx = this.tableData.findIndex(item=>(item.uniqueKey == row.uniqueKey));
                    this.$refs.table.toggleRowSelection(this.tableData[idx],false)
                    this.$message.error(this.$t('invoiceEntry_discount_invoices_can_only_be_selected_for_one_order'));
                    val.pop();
                    return
                }
                const isSelected = val.some(item => item.uniqueKey === row.uniqueKey);
                const islossrelate = this.tableData.find(item => item.i_lossrelate_id === row.i_lossrelate_id&&item.i_order_type==2&&item.uniqueKey!=row.uniqueKey);
                if(isSelected){
                    if(this.Data.row.f_je_ws_cw<0){
                        row.f_currentrelated_num=0;
                        row.f_currentrelate_num_fp=0;
                        row.f_price_ws=this.Data.row.f_price_ws_cw;
                        row.f_sl=this.Data.row.f_sl_cw;
                        row.f_je_ws=this.Data.row.f_je_ws_cw;
                        row.f_je_zzs=this.Data.row.f_je_zzs_cw;
                    }else{
                        row.f_currentrelated_num=row.f_canrelate_num;
                        row.f_currentrelate_num_fp=row.f_bl==0?0:this.preciseDiv(row.f_currentrelated_num,row.f_bl);
                        //row.f_price_ws=this.i_isfrom==1?this.form.f_price_ws:0;
                        //row.f_sl=this.form.f_sl;
                        row.f_price_ws=this.i_isfrom==1?this.form.f_price_ws_cw:0;
                        row.f_sl=this.form.f_sl_cw;
                        //let payws = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws;
                        let payws = parseFloat(row.f_currentrelated_num)*row.f_price_ws;
                        row.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                        //let payzzs = parseFloat(row.f_currentrelate_num_fp)*row.f_price_ws*row.f_sl;
                        let payzzs = parseFloat(row.f_currentrelated_num)*row.f_price_ws*row.f_sl;
                        row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                    }
                    this.multipleSelection = val;
                    //console.log(this.multipleSelection,'val')
                }else{
                    row.f_currentrelated_num=0;
                    row.f_currentrelate_num_fp=0;
                    row.f_price_ws=0;
                    row.f_je_ws=0;
                    row.f_sl=0;
                    row.f_je_zzs=0;
                    const islossrelate = this.tableData.find(item => item.i_lossrelate_id === row.i_lossrelate_id&&item.i_order_type==2&&item.uniqueKey!=row.uniqueKey);
                    if (islossrelate) {
                        this.$refs.table.toggleRowSelection(islossrelate, false);
                    }
                    this.multipleSelection = val;
                    //console.log(this.multipleSelection,'val')
                }
                if (islossrelate&&this.Data.row.f_je_ws_cw>0) {
                    islossrelate.f_currentrelated_num=islossrelate.f_canrelate_num;
                    islossrelate.f_currentrelate_num_fp=islossrelate.f_bl==0?0:parseFloat(this.preciseDiv(islossrelate.f_currentrelated_num,islossrelate.f_bl));
                    //islossrelate.f_price_ws=this.i_isfrom==1?this.form.f_price_ws:0;
                    //islossrelate.f_sl=this.form.f_sl;
                    islossrelate.f_price_ws=this.i_isfrom==1?this.form.f_price_ws_cw:0;
                    islossrelate.f_sl=this.form.f_sl_cw;
                    //let payws = islossrelate.f_currentrelate_num_fp*islossrelate.f_price_ws;
                    let payws = islossrelate.f_currentrelated_num*islossrelate.f_price_ws;
                    islossrelate.f_je_ws = parseFloat(this.keepTwoDecimal(payws));
                    //let payzzs = islossrelate.f_currentrelate_num_fp*islossrelate.f_price_ws*islossrelate.f_sl;
                    let payzzs = islossrelate.f_currentrelated_num*islossrelate.f_price_ws*islossrelate.f_sl;
                    islossrelate.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                    this.$refs.table.toggleRowSelection(islossrelate, true);
                    this.multipleSelection.push(islossrelate);
                    //console.log(this.multipleSelection,'this.multipleSelection')
                }
                this.changeselT()

            },
            handleSelectionChange(selection) {
                //console.log(selection,'selection')
                if (selection.length === 0) {
                    this.selectedPid = null;
                } else {
                    this.selectedPid = selection[0].i_pz_pid;
                }
                if(this.tableTotal==selection.length){
                    this.choozt=true
                }else{
                    this.choozt=false
                }
            },
            checkSelectable(row, index) {
                if (this.selectedPid === null) return true;
                return row.i_pz_pid === this.selectedPid;
            },
            changeselT(){
                this.selectedTotal = {
                    f_currentrelate_num_fp: 0,
                    f_je_ws: 0,
                    f_je_zzs: 0
                };
                this.multipleSelection.forEach(row => {
                    this.selectedTotal.f_currentrelate_num_fp += Number(row.f_currentrelate_num_fp) || 0;
                    this.selectedTotal.f_je_ws += Number(row.f_je_ws) || 0;
                    this.selectedTotal.f_je_zzs += Number(row.f_je_zzs) || 0;
                });
            },

            getSummaries({ columns }) {
                //console.log(columns,'columns')
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 1) {
                        sums[index] = this.$t('invoiceEntry_selected');
                        return;
                    }

                    if (['f_currentrelate_num_fp', 'f_je_ws', 'f_je_zzs'].includes(column.property)) {
                        const val = this.selectedTotal[column.property] || 0;
                        sums[index] = column.property=='f_currentrelate_num_fp'?val.toFixed(this.$setPrecision.quantityPrecision):val.toFixed(2);
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            // 查询费用列表
            async getOrders(isOrder){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    'i_id':this.form.i_fpid,
                    'i_kpkhid':this.form.i_kpkhid,
                    'i_gsid':this.form.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_fymx':this.form.vc_fymx,
                    //'i_over':this.i_over,
                    //'dt_startdate':this.dt_startdate,
                    //'dt_enddate':this.dt_enddate,
                    //'vc_search':this.vc_search,
                    //'i_checkstate':this.form.i_checkstate,
                    'i_isnew':0,
                    //'vc_fpunit':this.form.vc_fpunit?this.form.vc_fpunit:'',
                    'isOrder':isOrder,
                    'vc_no':this.form.vc_no,
                    'f_bl':this.form.f_bl,
                };
                let res = await API.getOrderList(param); //getOrderList
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData = res.data.list;
                    this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.$nextTick(() => {
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                row.disabled=false;
                                row.f_bl_copy=row.f_bl;
                                row.i_pid=this.form.i_fpdetailId;
                                row.orderId=this.form.i_order_pid;
                                row.vc_fpunit=this.form.vc_fpunit;
                                /*row.vc_fpunit=this.dataOrd.row.vc_fpunit;
                                row.f_currentrelate_num_fp=0;
                                row.f_price_ws=0;
                                row.f_je_ws=0;
                                row.f_sl=0;
                                row.f_je_zzs=0;
                                let arr = this.dataZt.select;
                                //console.log(arr,'arr')
                                const isSelected = arr.some(sel => sel.uniqueKey == row.uniqueKey);
                                const idx = arr.findIndex(sel => sel.uniqueKey === row.uniqueKey);
                                table.toggleRowSelection(row, isSelected);
                                if(isSelected){
                                    row.f_currentrelate_num_fp=arr[idx].f_currentrelated_num;
                                    row.f_price_ws=arr[idx].f_price_ws;
                                    row.f_je_ws=arr[idx].f_je_ws;
                                    row.f_sl=arr[idx].f_sl;
                                    row.f_je_zzs=arr[idx].f_je_zzs;
                                    row.f_currentrelated_num=arr[idx].f_currentrelated_num;
                                    this.multipleSelection.push(row);
                                    console.log(this.multipleSelection,'this.multipleSelection');
                                    this.changeselT()
                                }*/
                            });
                        }
                    });
                    /*let arr = this.Data.select;
                    console.log(arr,'arr')
                    this.tableData=this.tableData.filter(itemB => !arr.some(itemA => itemA.uniqueKey === itemB.uniqueKey));
                    console.log("data",this.tableData)*/
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders(0);
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getOrders(0);
            },

            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders(0);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders(0);
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            confirm() {
                const { selectedTotal, remain, form } = this
                //console.log(selectedTotal,'selectedTotal',remain,'remain',form,'form')
                const equal =
                    this.keepTwoDecimal(selectedTotal.f_currentrelate_num_fp)   <=  this.keepTwoDecimal( remain.f_num_fp)
                if (!equal) {
                    this.$message.warning(this.$t('invoiceEntry_the_currently_selected_data_volume_cannot_exceed_the_remaining_available_volume'))
                    return
                }
                const equal2 =
                    this.keepTwoDecimal(   selectedTotal.f_je_ws ) <= this.keepTwoDecimal( remain.f_je_ws_cw ) &&
                    this.keepTwoDecimal(   selectedTotal.f_je_zzs ) <=   this.keepTwoDecimal(remain.f_je_zzs_cw)
                if (!equal2) {
                    this.$message.warning(this.$t('invoiceEntry_the_currently_selected_tax-inclusive_amount_cannot_exceed_the_remaining_tax-inclusive_amount'))
                    return
                }
                const hasZero = this.multipleSelection.some(item => item.f_currentrelate_num_fp == 0||Number.isNaN(item.f_currentrelate_num_fp));
                if(hasZero&&this.Data.row.f_je_ws_cw>0){
                    this.$message.warning(this.$t('invoiceEntry_the_number_of_invoices_is_0'))
                    return
                }
                //console.log(this.multipleSelection,'this.multipleSelection')
                this.dialogVisible_choo=true;
                //this.$emit('confirmzt', this.multipleSelection)

            },
            cancel(){
                this.$emit('confirmzt',{type:'back'});
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    /deep/.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 0px !important;
    }
    /* 隐藏 el-table 的全选框 */
    /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }



    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }


    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
